export default __webpack_public_path__ + "static/media/a005-general2024.76b48352.png";